const details = {
    name: "ساوین گالری",
    enName: "shop",
    description: "ساوین گالری",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "طراحی سایت جواهری",
        link: "https://barantm.com/landing/gold-website-design"
    }
}

export default details;
